
import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'
export const Number: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
  }
> = ({ name, defaultValue, errors, label, register, required, width }) => {
  // Allow only characters that can make up the valid phone formats
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedChars = /[0-9\-\s\(\)]/
    if (!allowedChars.test(event.key)) {
      event.preventDefault()
    }
  }

  const PHONE_REGEX = /(^(\(\d{3}\)\s\d{3}-\d{4})$)|(^\d{3}-\d{3}-\d{4}$)/

  return (
    <Width width={width}>
      <Label htmlFor={name} className="block text-sm font-medium text-foreground mb-2">
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Input
        defaultValue={defaultValue}
        id={name}
        type="text"
        {...register(name, {
          required: required ? 'This field is required' : false,
          pattern: {
            value: PHONE_REGEX,
            message: 'Enter a valid phone number: (555) 555-5555 or 555-555-5555',
          },
        })}
        onKeyPress={handleKeyPress}
        className="w-full px-4 py-3 border border-gray-300 focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-all"
        style={{
          appearance: 'none',
          MozAppearance: 'textfield',
          WebkitAppearance: 'none',
        }}
      />
      {errors[name] && <Error message={(errors as any)[name]?.message} />}
    </Width>
  )
}
